import React from "react";
import {
  FlatActionList,
  FlatActionListItem,
  Page,
} from "@towersystems/roam-common-native";
import { useFormContext } from "react-hook-form";
import { Feather } from "@expo/vector-icons";
import { StackScreenProps } from "@react-navigation/stack";
import { useTranslation } from "react-i18next";
import {
  CashRounding,
  PaymentMethodFormValues,
} from "../PaymentMethodForm/types";

const options = [
  {
    label: "0.05 Cash Demonination (AU)",
    value: CashRounding.ROUND_TO_05,
    description: "e.g for 0.05 rounding, round to nearest 0.05",
  },
  {
    label: "0.10 Cash Demonination (NZ)",
    value: CashRounding.ROUND_TO_10,
    description: "e.g for 0.10 rounding, round to nearest 0.10",
  },
  {
    label: "No Cash Rounding",
    value: CashRounding.NONE,
    description: "No rounding applied, just use the exact amount.",
  },
];

export type SelectCashRoundingScreenProps = StackScreenProps<
  any,
  "SelectCashRoundingScreen"
>;

export const SelectCashRoundingScreen = ({
  navigation,
}: SelectCashRoundingScreenProps) => {
  const { t } = useTranslation("settings");

  const { watch, setValue } = useFormContext<PaymentMethodFormValues>();

  const watchedRoundingAlgorithm = watch("rounding.cashRounding");

  const items: FlatActionListItem[] = React.useMemo(() => {
    return options.map((option) => ({
      id: option.value,
      key: option.value,
      title: option.label,
      subTitle: option.description,
      icon: <Feather name="check" size={24} color="black" />,
      onPress: () => {
        setValue("rounding.cashRounding", option.value, {
          shouldValidate: true,
          shouldDirty: true,
        });
        navigation.goBack();
      },
      selected: watchedRoundingAlgorithm === option.value,
    }));
  }, [watchedRoundingAlgorithm]);

  return (
    <Page title={t("modal_select_cash_rounding_title")}>
      <FlatActionList items={items} />
    </Page>
  );
};
